import styled from '@emotion/styled/macro';

export const EnteredWrapper = styled.div`
    width: 100%;
    border-radius: 2px;
    display: flex;
    justify-content: center;
`;

export const EnteredContentWrapper = styled.div`
    width: 100%;
    text-align: center;
`;

export const Title = styled.h1`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-weight: 700;
    font-size: ${props => props.theme.fontSize.xlarge};
    line-height: 28px;
    margin-bottom: ${props => props.theme.spacing.xlarge};
    text-transform: uppercase;
`;

export const Text = styled.p`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 400;
    line-height: 22px;
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const PrizeText = styled(Text)`
    max-width: 486px;
    margin: 20px auto 16px auto;
`;

export const Highlighted = styled.span`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: bold;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 24px auto 12px auto;
    justify-content: center;

    @media (max-width: 1023px) {
        flex-direction: column;
        align-items: center;

        & div:nth-of-type(2n) {
            margin: 12px 8px 0 8px;
        }
    }
`;

export const ButtonWrapper = styled.div`
    height: 48px;
    width: 100%;
    max-width: 343px;
    display: flex;
    margin: 0 8px;

    @media (max-width: 1023px) {
        margin: 0;
    }

    @media (max-width: 320px) {
        min-width: auto;
        max-width: 98%;
    }
`;

export const LinkWrapper = styled.a`
    width: 100%;
`;
